import { TextField, Typography } from "@mui/material";
import { useAppContext } from "../../../../../../2_ksbHub/context/appContext";

export default function BszReservationSearch({
  hasReservations,
  query,
  onChange,
}) {
  const { isMobile } = useAppContext();

  if (!hasReservations) {
    return (
      <Typography sx={{ opacity: 0.6 }}>
        {isMobile ? "❌ Niemand da" : "❌ Niemand eingetragen"}
      </Typography>
    );
  }

  return (
    <TextField
      size="small"
      placeholder="Name suchen…"
      value={query}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
